<template>
  <div>
    <a :href="newsUrl" target="_blank">
      <span class="sub-title">{{ newDate }} {{ newsType }}</span><br>
      <span v-if="icsType" :class="['ics-tag', `is-${icsType}`]">{{ icsTagText }}</span>
      <span class="title">{{ news.title }}</span>
    </a>
  </div>
</template>

<script>
export default {
  props: {
    news: {
      type: Object,
      required: true,
    },
    buildingPage: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
    };
  },
  computed: {
    newDate() {
      return this.news.post_date;
    },
    newsType() {
      if (this.buildingPage) {
        return this.news.categories;
      }
      let type = 'NEWS';
      if (this.news.custom_post_type === 'ics_news') {
        type = 'NEWS';
      }
      if (this.news.custom_post_type === 'daily_news') {
        type = 'DAILYNEWS';
      }
      if (this.news.custom_post_type === 'analysis') {
        type = 'ANALYSIS_REPORT';
      }

      return this.$t(`details.${type}`);
    },
    newsUrl() {
      return `/ics/property/article/detail/${this.news.post_id}`;
    },
    icsType() {
      if (this.news.ics_type.length > 1 || this.news.ics_type.length === 0) {
        return 'ics';
      }
      return `${this.news.ics_type[0]}`;
    },
    icsTagText() {
      let output = '';
      switch (this.icsType) {
        case 'i':
          output = this.$t('find.IND_SS');
          break;
        case 'c':
          output = this.$t('find.COMM_SS');
          break;
        case 's':
          output = this.$t('find.SHOP_SS');
          break;
        case 'ics':
          output = this.$t('find.ALL_SS');
          break;
        default:
          break;
      }
      return output;
    },
  },
};
</script>

<style scoped>
.title {
  color: #000000;
}

.sub-title {
  font-size: 1rem;
  color: #a8a086;
}


.ics-tag {
  width: 20px;
  height: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 3px;
  color: #ffffff;
  font-size: 1rem;
}

.ics-tag.is-ics {
  background: #FEE100;
  border-color: #FEE100;
  color: #000000;
}

.ics-tag.is-i {
  background: #47337C;
  border-color: #47337C;
}

.ics-tag.is-c {
  background: #008CBA;
  border-color: #008CBA;
}

.ics-tag.is-s {
  background: #DA4E00;
  border-color: #DA4E00;
}
</style>